// extracted by mini-css-extract-plugin
export default {"tel":"Step_tel__zuZWf","sms_text":"Step_sms_text__0Xbiy","button_send":"Step_button_send__XMOAN","error":"Step_error__aZawJ"};